const requestBtns = document.querySelectorAll('.request-btn');
const popup = document.querySelector('.popup');
const overlay = document.querySelector('.overlay');
const popupCloseBtn = document.querySelector('.popup__close-btn');

const togglePopup = () => {
    overlay.classList.toggle('overlay_hide');
    popup.classList.toggle('popup_opened');

    if (!popup.classList.contains('popup_opened')) {        // popup closed
        const body = document.body;
        const scrollY = body.style.top;
        body.style.position = '';
        body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    } else {                                                // popup opened
        const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
        const body = document.body;
        body.style.position = 'fixed';
        body.style.width = '100%';
        body.style.top = `-${scrollY}`;
    }
}

requestBtns.forEach((btn) => btn.addEventListener('click', togglePopup));
popupCloseBtn.addEventListener('click', togglePopup);


window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
});
